export default __webpack_public_path__ + "static/media/agriculture.90ca6364.png";